<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="选择类型" prop="endDate">
            <el-select v-model="queryParams.type" placeholder="请选择">
              <el-option
                v-for="item in selectData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>每日体力消耗占比</span>
        </div>

        <el-table
          :data="tableData"
          border
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
            width="130"
          />
          <el-table-column
            v-for="(item, index) in rangeTitle"
            :key="index"
            :label="item"
            align="center"
          >
            <el-table-column
              label="人数"
              align="center"
            >
              <template v-slot:default="scope">
                {{ tableData[scope.$index]['spin'+(index+2)] }}
              </template>
            </el-table-column>
            <el-table-column
              label="占比"
              align="center"
            >
              <template v-slot:default="scope">
                {{ tableData[scope.$index]['spin'+(index+1)+'Rate'] }}%
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-card>

      <el-row :gutter="12">
        <userStat ref="userStat" :title="'人数'" />
      </el-row>

      <el-row :gutter="12">
        <userStat ref="userStatRate" :title="'占比'" :k="'rate'" />
      </el-row>

    </template>
  </BasicLayout>
</template>

<script>
import userStat from '@/views/config/user-consume-spins-stat/components/user-stat.vue'
import { getCacheQuery, getLastDates, getUserConsumeLabel, scientificFormat, setCacheQuery } from '@/utils'
import { getUserConsumeDataStat } from '@/api/statistics/user_remain'
export default {
  name: 'UserConsumeSpinsStat',
  components: {
    userStat
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        type: 0
      },
      rangeTitle: ['1-10', '11-50', '51-200', '201-500', '501-1000', '1001-1500', '1501-2000', '2000+'],
      selectData: {},
      tableData: [],
      data: {}
    }
  },
  created() {
    this.selectData = getUserConsumeLabel()
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }

    this.getTables(undefined)
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables(event) {
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getUserConsumeDataStat(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          if (res.data.length <= 0) {
            return
          }
          this.tableData = res.data.data
          this.$refs.userStat.refresh(res.data.data, this.rangeTitle)
          this.$refs.userStatRate.refresh(res.data.data, this.rangeTitle)
          this.tableData = res.data.data
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
